<template>
<div ref="nav" class="nav" :class="{'nav-fixed':navfixed}">
<div class="nav-wrap" >	
	<div class="wrap clear">
		<ul class="nav-list">	
			<template v-for="(v,i) in navsList">
			<li class="nav-item" :key="i"
				:class="{'active-in':v.href == $route.path}"
			>			
				<a :href="hrefShow(v.href)" :target="v.href === '/hqonline' ? '_blank' : v.target ? v.target : '_self' "> 
					{{v.name}} 
					<i v-show="v.hasNewicon" class="new-text-icon-animation" style="right: 6px;">{{languagePackage.LANG[v.hasNewicon] || 'Hot'}}</i>
					<img v-if="v.navIcon" :class="{'new-icon-animation': v.iconAnimation}" style="position: absolute;top: -13px; right: 4px;" :src="v.navIcon">
				</a>
				<template v-if="v.child && v.child.length">
					<div class="nav-sub trans-animate">
						<template v-for="(m,n) in v.child">
							<a :href="hrefShow(m.href)" :target="v.href === '/hqonline' ? '_blank' : v.target ? v.target  : '_self'" :key="100 + n" style="position: relative;min-width: 150px;">
								{{m.name}}
								<img v-if="m.navIcon" :class="{'sub-new-icon-animation': m.iconAnimation}" style="position: absolute;top: -4px; right: 14px;" :src="m.navIcon">
							</a>
						</template>
					</div>
				</template>
			</li>
			</template>
			
		</ul>	
	</div>
</div>
</div>
</template>

<script>
export default {
	name:"DfmNav2",
	data(){
		return {
			navfixed:false,
			subIsShow: false
		}
	},
	computed:{
		navConfig(){
			console.log(85, this.$store.getters.getNavList)
			return this.$store.getters.getNavList || {};
		},
		languagePackage(){
			return this.$store.getters.getLanguangeData || {LANG:{},MLANG:{}};
		},
		navsList(){
			const list = [
				{
					"name":this.languagePackage.LANG.home,
					"routeName":"home",
					"href":"/"
				},
				{
					"name":this.languagePackage.LANG.pcb_quote,
					"routeName":"quote",
					"href":"/pcb-quote",
					"child":[]
				},
				{
					"name":this.languagePackage.LANG.pcb_assembly,
					"routeName":"pcb_assembly",
					"href":"/pcb-assembly-quote",
					"child":[]
				},
				// {
				// 	"name":this.languagePackage.LANG.bom_service,
				// 	"routeName":"bom_service",
				// 	"href":"/bom-service"
				// },
				// {
				// 	"name":this.languagePackage.LANG.stencil,
				// 	"routeName":"pcb_stencil_quote",
				// 	"href":"/pcb-stencil-quote"
				// },
				{
					"name":this.languagePackage.LANG.components_sourcing,
					"href":"/hqonline",
					"hasNewicon":"Hot",
					"routeName":"hqonline",
				},
				{
					"name":this.languagePackage.LANG.about_us,
					"routeName": ["about","whyus","shipment"],
					"href":"/about-nextpcb",
					"child":[]
				}
			]
			return list
		},
		__IMG__(){
			return process?.env?.VUE_APP_STATIC + '/images'
		}
	},
	mounted(){
		window.addEventListener('scroll', this.handleFixed)
		window.addEventListener('resize', this.handleResize)
		const prodSub = document.getElementsByClassName('yui-nav-product')[0]
		prodSub.addEventListener('mouseenter', () => {
			this.subIsShow = true
			document.getElementsByClassName('nav-product')[0].classList.remove('hide-hover-sub')
		})
		prodSub.addEventListener('mouseleave', () => {
			this.subIsShow = false
			document.getElementsByClassName('nav-product')[0].classList.add('hide-hover-sub')
		})
	},
	beforeDestroy(){
		window.removeEventListener('scroll', this.handleFixed)
		window.removeEventListener('resize', this.handleResize)
	},
	methods: {
		// 导航跳转链接
		hrefShow(href) {
			if(href === '/hqonline') {
				return this.$tools.getHqonlineUrl()
			} else {
				return href
			}
		},
		handleFixed(){
			let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;	
			let offsetTop = this.$refs.nav.offsetTop;
			if(scrolltop > offsetTop){
				this.navfixed = true;
			}else{
				this.navfixed = false;
			}
			this.$store.commit('setIsFixed',this.navfixed)
			if (this.subIsShow) {
				document.getElementsByClassName('yui-nav-product')[0].dispatchEvent(new MouseEvent('mouseleave'))
			}
		},
		handleResize(){
			let flag = false
			const wWidth = window.innerWidth
			if(wWidth < 1240){
				flag = true
			}
			this.$store.commit('setIsMinWidth',flag)
		}
	}
	
}
</script>

<style lang="scss">
$navHeight: 48px;
$subitemHeight: 22px;
.nav {
	position: relative;
	z-index: 23;
	height: $navHeight;
	&-wrap {
		background-color: #fff;
		height: $navHeight;
	}
	&-list {
		display: flex;
		position: relative;
    // justify-content: space-between;
	}
	//-fixed
	&-fixed {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 101;
	}
	//nav-btn
	&-btn {
		float: right;
		margin-top: 9px;
	}
	//nav-item
	&-item {
		display: inline-block;
		&>a {
			line-height: $navHeight;
			color: $color-gray-xl;
			font-weight: bold;
			padding: 0 $space-padding-md;	
			font-size: 13px;
			position: relative;
		}
		&:hover,&.active {
			// background: #180444;
			&>a {
				color: #CC0000;
			}
			.nav-sub {
				position: absolute;
				display: block;
				margin-left: 10px;
				background-color: $color-bg-bs;
				box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
			}
		}
	}
	//nav-sub
	&-sub {
		display: none;
		padding: $space-padding-sm $space-padding-md;
		a {
			display: block;
			height: $subitemHeight;
			line-height: $subitemHeight;
			
			&:hover{
				color: #CC0000;
				text-decoration: underline;
			}
		}
		.nav-product-box dd a{
			position: relative;
		}
	}
	//nav-product
	&-product {
		width: 1200px;
		box-sizing: border-box;
		padding: 25px 30px;
		margin-left: 0 !important;
		left: 0;
		// left: 50%;
		// transform: translateX(-50%);

		&-box {
			width: 100%;
			font-size: 0;
			display: flex;
			justify-content: space-between;
			box-sizing: border-box;
		}

		&-menu {
			width: 890px;
			display: flex;
			justify-content: space-between;
			flex: 1;

			&-col {
				width: 200px;
				.hr-line {
					width: 100%;
					height: 1px;
					border-bottom: 1px solid #e1e1e1;
					margin: 10px 0 13px;
				}
				dt {
					img {
						width: 28px;
					}
					.title {
						display: block;
						font-size: 14px;
						font-weight: 700;
						line-height: 30px;
						position: relative;
						&::after {
							content: '';
							display: block;
							width: 43px;
							height: 1px;
							border-bottom: 1px solid #cc0000;
							position: absolute;
							left: 0;
							bottom: 0;
						}
					}
				}
				dd {
					margin-top: 5px;
					a {
						font-size: 12px;
						line-height: 22px;
						white-space: nowrap;
						display: block;
						&:hover{
							color: #cc0000;
							text-decoration: underline;
						}
					}
				}
			}
		}

		&-adv {
			width: 250px;
			box-sizing: border-box;
			padding: 5px 0;
			margin-left: 30px;

			a {
				height: auto;
				line-height: normal;
				&:hover {
					color: unset;
					text-decoration: none;
				}
			}

			&-box {
				width: 100%;
				height: 255px;
				background: #f5f6f8;
				box-sizing: border-box;
				padding: 10px 0;

				.img-box {
					width: 100%;
					img {
						width: 132px;
					}
					text-align: center;
				}

				.pcb-text-box{
					box-sizing: border-box;
					padding: 0 28px;
					b {
						display: block;
						font-size: 22px;
						font-weight: 700;
						
						em {
							font-size: 22px;
							font-weight: 700;
							display: inline-block;
							color: #cc0000;
							strong {
								font-size: 28px;
							}
						}
					}

					p {
						font-size: 14px;
						font-weight: 700;
						margin: 8px 0 11px 0;
					}

					span {
						font-size: 12px;
						line-height: 20px;
						display: block;
					}
				}

				.pcba-text-box{
					margin-top: 8px;
					box-sizing: border-box;
					padding: 0 25px;
					b {
						display: block;
						font-size: 20px;
						font-weight: 700;
						line-height: 26px;
						
						em {
							font-size: 20px;
							font-weight: 700;
							display: inline-block;
							color: #cc0000;
						}
					}

					span {
						font-size: 12px;
						line-height: 22px;
						display: block;
						margin-top: 16px;
					}
				}
			}
		}
	}
	//active-in
	.active-in {
		&>a {
			font-weight: 700;
			color: #CC0000;
		}
	}

	@keyframes movepoint {
    25% {
      top: -12px
    }
    100% {
      top: -16px
    }
	}
	.new-text-icon-animation {
		position: absolute;
    top: -16px;
    right: 0px;
    background: #CC0000;
    font-size: 12px;
    color: #fff;
    height: 14px;
    line-height: 14px;
    border-radius: 3px;
    padding: 1px 2px;
		animation: movepoint 2s infinite;
		&::before {
			content: '';
			width: 0;
			height: 0;
			border-left: 3px solid transparent;
			border-right: 3px solid transparent;
			border-top: 3px solid #CC0000;
			position: absolute;
			left: 10px;
			bottom: -2px;
		}
	}
	.new-icon-animation {
		animation: movepoint 2s infinite;
	}

	@keyframes sub-movepoint {
		25% {
			top: 0px
		}
		100% {
			top: -4px
		}
	}
	.sub-new-icon-animation {
		animation: sub-movepoint 2s infinite;
	}
}
</style>
